/**
 * @file
 * Checkout scripts.
 */

const $checkoutForm = $('.checkout-form', context);

$checkoutForm.once('form-checkout').each((index, el) => {
  const $this = $(el);

  // Hide/show summary on mobile.
  const $summaryShow = $this.find('.summary-title-show');
  const $summaryHide = $this.find('.summary-title-hide');
  const $summaryMobile = $this.find('.checkout-summary-sm');
  const $summaryContent = $this.find('.checkout-summary-content');

  $summaryMobile.click(event => {
    event.preventDefault();
    if (!$summaryContent.is(':visible')) {
      $summaryContent.show();
      $checkoutForm.addClass('is-open');
      $summaryShow.hide();
      $summaryHide.show();
    } else {
      $summaryContent.hide();
      $checkoutForm.removeClass('is-open');
      $summaryShow.show();
      $summaryHide.hide();
    }
  });

  // Total amount.
  const total = $this
    .find('.order-total-line__total .order-total-line-value')
    .text();
  $this.find('.checkout-summary-sm-price').text(total);

  function calculateSidebarHeight() {
    const $sidebarInner = $this.find('.checkout-summary-content-inner');
    $sidebarInner.css('height', '');

    const $sidebarPrice = $this.find('.field-name-total-price');
    $sidebarInner.css(
      'height',
      $sidebarInner.height() + $sidebarPrice.height()
    );
  }

  // Set items height for long checkout forms.
  calculateSidebarHeight();

  $(document).ajaxComplete(() => calculateSidebarHeight());
});

// Postal code input format.
const notAlphaNumeric = /[^a-zA-Z0-9]/g;
$('input.postal-code', context)
  .once('zip-code-input')
  .each(function() {
    const $this = $(this);
    $this.on('keyup change', () => {
      const value = $this.val();
      const cleanValue = value.replace(notAlphaNumeric, '');
      if (value !== cleanValue) {
        $this.val(cleanValue);
      }
    });
  });
